var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.92871V13.5001C1 16.2224 5.2984 18.4287 10.6 18.4287C15.9016 18.4287 20.2 16.2224 20.2 13.5001V6.92871",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.5V20.0714C1 22.7936 5.2984 25 10.6 25C15.9016 25 20.2 22.7936 20.2 20.0714V13.5",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.0713V26.6427C1 29.3649 5.2984 31.5713 10.6 31.5713",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 26.6426V33.214C1 35.9362 5.2984 38.1426 10.6 38.1426",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 11.8571C15.9019 11.8571 20.2 9.65054 20.2 6.92857C20.2 4.2066 15.9019 2 10.6 2C5.29807 2 1 4.2066 1 6.92857C1 9.65054 5.29807 11.8571 10.6 11.8571Z",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 13.5V20.0714C29.8 22.7936 34.0984 25 39.4 25C44.7016 25 49 22.7936 49 20.0714V13.5",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4 31.5713C44.7016 31.5713 49 29.3649 49 26.6427V20.0713",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4 38.1426C44.7016 38.1426 49 35.9362 49 33.214V26.6426",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4 18.4285C44.7019 18.4285 49 16.2219 49 13.4999C49 10.7779 44.7019 8.57135 39.4 8.57135C34.0981 8.57135 29.8 10.7779 29.8 13.4999C29.8 16.2219 34.0981 18.4285 39.4 18.4285Z",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4 36.5V43.0714C15.4 45.7936 19.6984 48 25 48C30.3016 48 34.6 45.7936 34.6 43.0714V36.5",
    fill: "#FF98B1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 36.5V43.0714C15.4 45.7936 19.6984 48 25 48C30.3016 48 34.6 45.7936 34.6 43.0714V36.5",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4 29.9287V36.5001C15.4 39.2224 19.6984 41.4287 25 41.4287C30.3016 41.4287 34.6 39.2224 34.6 36.5001V29.9287",
    fill: "#FF98B1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 29.9287V36.5001C15.4 39.2224 19.6984 41.4287 25 41.4287C30.3016 41.4287 34.6 39.2224 34.6 36.5001V29.9287",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25 34.8571C30.302 34.8571 34.6 32.6505 34.6 29.9286C34.6 27.2066 30.302 25 25 25C19.6981 25 15.4 27.2066 15.4 29.9286C15.4 32.6505 19.6981 34.8571 25 34.8571Z",
    fill: "#FEB6C8",
    stroke: "#E40038",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.055424a240df0ce59bd7bed8482e5fc8.svg";
export { ForwardRef as ReactComponent };